import { render, staticRenderFns } from "./PaymentInfoPage.vue?vue&type=template&id=664cd87d&scoped=true&"
import script from "./PaymentInfoPage.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfoPage.vue?vue&type=style&index=0&id=664cd87d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664cd87d",
  null
  
)

export default component.exports